import { Component, OnInit, Input} from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs';

import { VisitService } from './visit.service';
import { PatientService } from '../patients/patient.service';
import { AuthenticationService } from '../shared/authentication.service';
import { MedicalHistoryService } from '../patients/medical-history.service';
import { parseErrors } from '../shared/api.service';
import { Visit } from './visit'

@Component({
  selector: 'visit',
  templateUrl: 'visit.component.html',
  styleUrls: ['./visit.component.scss']
})

export class VisitComponent implements OnInit {
  @Input() visit;
  loading = false;
  errors = [];
  activeTab = 'facesheet';
  visitReq;
  historyReq;
  patientReq;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private visitService: VisitService,
    private patientService: PatientService,
    private medicalHistoryService: MedicalHistoryService,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    let combinedParams = Observable.combineLatest(
      this.route.params, this.route.queryParams,
      (params, qparams) => ({ params, qparams })
    );

    combinedParams.subscribe(result => {
      this.loading = true;
      this.activeTab = result.qparams['tab'];

      this.getVisit(result.params['visitId']);
    });
  }

  getVisit(visitId) {
    if (this.visitReq) { this.visitReq.unsubscribe(); }
    this.visitReq = this.visitService.getVisit(visitId).subscribe(visit => {
      this.visit = visit;
      this.getPatient(visit && visit.patient && visit.patient.id);
      this.getMedicalHistory(visit && visit.patient && visit.patient.id);
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err);
    });
  }

  getMedicalHistory(patientId) {
    if (this.historyReq) { this.historyReq.unsubscribe(); }
    this.historyReq = this.medicalHistoryService.getMedicalHistory(patientId).subscribe(medicalHistory => {
      this.visit.medicalHistory = medicalHistory;
      this.loading = false;
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err);
    });
  }

  getPatient(patientId) {
    if (this.patientReq) { this.patientReq.unsubscribe(); }
    this.patientReq = this.patientService.getPatient(patientId).subscribe(patient => {
      this.visit.patient = patient;
      this.loading = false;
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err);
    });
  }

  tabChanged(event) {
    let index = event.index;
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['tab'] = index;
    this.router.navigate(['visits', this.visit.id], { queryParams: queryParams });

  }
}



// WEBPACK FOOTER //
// ./src/app/visits/visit.component.ts